<script lang="ts" setup>
import BlocksPageCharater from '~/components/@pages/blocks/BlocksPageCharater.vue'
import BlockAiSummary from '~/components/@pages/blocks/[blockNumber]/BlockAiSummary.vue'
import BlocksPageSummary from '~/components/@pages/blocks/BlocksPageSummary.vue'
import BlocksPageTabs from '~/components/@pages/blocks/BlocksPageTabs.vue'
import BackButton from '~/components/button/BackButton.vue'

const blockNumber = ref(useRoute().params.blockNumber as string)

useSeoMeta(getMeta(`Block ${blockNumber.value}`, `Explore details of Block ${blockNumber.value}`))
</script>

<template>
  <div class="relative">
    <BackButton :url="routes.getBlockListPage()" />
    <BlocksPageSummary />
    <div class="my-4 border-t border-t-primary/10" />
    <BlockAiSummary />
    <div class="my-4 border-t border-t-primary/10" />
    <BlocksPageTabs class="block-tabs" />
    <div class="relative">
<!--      <BlocksPageCharater class="block-character" />-->
      <NuxtPage />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-tabs {
  @apply mt-4 relative z-10;

  @include sm {
    @apply mt-4 static z-0;
  }
}

.block-character {
  @apply -top-40 right-8;

  @include md {
    @apply -top-20 right-4;
  }

  @include sm {
    @apply -top-[154px] -right-4;
  }
}
</style>